import { gql } from '@apollo/client';

export const QUERY_ALL_POSTS = gql`
  query AllPosts($lang: LanguageCodeFilterEnum!) {
    posts(first: 10000, where: { language: $lang }) {
      edges {
        node {
          author {
            node {
              avatar {
                height
                url
                width
              }
              id
              name
              slug
            }
          }
          id
          categories {
            edges {
              node {
                categoryId
                id
                name
                slug
              }
            }
          }
          content
          date
          excerpt
          featuredImage {
            node {
              altText
              caption
              sourceUrl
              srcSet
              sizes
              id
            }
          }
          modified
          postId
          title
          slug
          isSticky
          videoNews {
            fieldGroupName
            videoUrl
          }
        }
      }
    }
  }
`;

export const QUERY_POST_BY_SLUG = gql`
  query PostBySlug($slug: ID!, $lang: LanguageCodeEnum!) {
    post(id: $slug, idType: SLUG) {
      translation(language: $lang) {
        author {
          node {
            avatar {
              height
              url
              width
            }
            id
            name
            slug
          }
        }
        id
        categories {
          edges {
            node {
              categoryId
              id
              name
              slug
            }
          }
        }
        content
        date
        excerpt
        featuredImage {
          node {
            altText
            caption
            sourceUrl
            srcSet
            sizes
            id
          }
        }
        modified
        postId
        title
        slug
        isSticky
        videoNews {
          fieldGroupName
          videoUrl
        }
        status
      }
    }
  }
`

export const QUERY_POSTS_BY_CATEGORY_ID = gql`
  query PostsByCategoryId($categoryId: Int!) {
    posts(where: { categoryId: $categoryId, orderby: {field: DATE, order: DESC}, status: PUBLISH}) {
      edges {
        node {
          author {
            node {
              avatar {
                height
                url
                width
              }
              id
              name
              slug
            }
          }
          id
          categories {
            edges {
              node {
                categoryId
                id
                name
                slug
              }
            }
          }
          content
          date
          excerpt
          featuredImage {
            node {
              altText
              caption
              id
              sizes
              sourceUrl
              srcSet
            }
          }
          modified
          postId
          title
          slug
          isSticky
        }
      }
    }
  }
`;

export const QUERY_POSTS_CATEGORY_ID_BY_YEAR = gql`
  query PostsByCategoryId($categoryId: Int!, $year: Int!) {
    posts(where: {categoryId: $categoryId, orderby: {field: DATE, order: DESC}, dateQuery: {year: $year}, status: PUBLISH}) {
      edges {
        node {
          author {
            node {
              avatar {
                height
                url
                width
              }
              id
              name
              slug
            }
          }
          id
          categories {
            edges {
              node {
                categoryId
                id
                name
                slug
              }
            }
          }
          content
          date
          excerpt
          featuredImage {
            node {
              altText
              caption
              id
              sizes
              sourceUrl
              srcSet
            }
          }
          modified
          postId
          title
          slug
          isSticky
        }
      }
    }
  }
`

export const QUERY_POSTS_CATEGORY_ID_BY_KW = gql`
  query PostsByCategoryId($categoryId: Int!, $kw: String!) {
    posts(where: {categoryId: $categoryId, search: $kw, orderby: {field: DATE, order: DESC}, status: PUBLISH}) {
      edges {
        node {
          author {
            node {
              avatar {
                height
                url
                width
              }
              id
              name
              slug
            }
          }
          id
          categories {
            edges {
              node {
                categoryId
                id
                name
                slug
              }
            }
          }
          content
          date
          excerpt
          featuredImage {
            node {
              altText
              caption
              id
              sizes
              sourceUrl
              srcSet
            }
          }
          modified
          postId
          title
          slug
          isSticky
        }
      }
    }
  }
`

export const QUERY_POSTS_CATEGORY_ID_BY_YEAR_KW = gql`
  query PostsByCategoryId($categoryId: Int!, $year: Int!, $kw: String!) {
    posts(where: {categoryId: $categoryId, dateQuery: {year: $year}, search: $kw, orderby: {field: DATE, order: DESC}, status: PUBLISH}) {
      edges {
        node {
          author {
            node {
              avatar {
                height
                url
                width
              }
              id
              name
              slug
            }
          }
          id
          categories {
            edges {
              node {
                categoryId
                id
                name
                slug
              }
            }
          }
          content
          date
          excerpt
          featuredImage {
            node {
              altText
              caption
              id
              sizes
              sourceUrl
              srcSet
            }
          }
          modified
          postId
          title
          slug
          isSticky
        }
      }
    }
  }
`

export const QUERY_POSTS_BY_AUTHOR_SLUG = gql`
  query PostByAuthorSlug($slug: String!) {
    posts(where: { authorName: $slug }) {
      edges {
        node {
          categories {
            edges {
              node {
                categoryId
                id
                name
                slug
              }
            }
          }
          date
          excerpt
          featuredImage {
            node {
              altText
              caption
              id
              sizes
              sourceUrl
              srcSet
            }
          }
          id
          modified
          postId
          slug
          title
          isSticky
        }
      }
    }
  }
`;

export const QUERY_POST_SEO_BY_SLUG = gql`
  query PostSEOBySlug($slug: ID!, $lang: LanguageCodeEnum!) {
    post(id: $slug, idType: SLUG) {
      translation(language: $lang) {
        id
        seo {
          canonical
          metaDesc
          metaRobotsNofollow
          metaRobotsNoindex
          opengraphAuthor
          opengraphDescription
          opengraphModifiedTime
          opengraphPublishedTime
          opengraphPublisher
          opengraphTitle
          opengraphType
          readingTime
          title
          twitterDescription
          twitterTitle
          twitterImage {
            altText
            sourceUrl
            mediaDetails {
              width
              height
            }
          }
          opengraphImage {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
`;

export const QUERY_POST_PER_PAGE = gql`
  query PostPerPage {
    allSettings {
      readingSettingsPostsPerPage
    }
  }
`;

export const QUERY_POST_BY_POST_ID = gql`
  query PostById {
    post(id: $postId, idType: DATABASE_ID) {
        author {
          node {
            avatar {
              height
              url
              width
            }
            id
            name
            slug
          }
        }
        id
        categories {
          edges {
            node {
              categoryId
              id
              name
              slug
            }
          }
        }
        content
        date
        excerpt
        featuredImage {
          node {
            altText
            caption
            sourceUrl
            srcSet
            sizes
            id
          }
        }
        modified
        postId
        title
        slug
        isSticky
      }
  }
`;

export const QUERY_POSTS_YEARS_BY_CATEGORY_ID = gql`
query PostsYearsByCategoryId($categoryId: Int!) {
  posts(
    where: {categoryId: $categoryId, orderby: {field: DATE, order: ASC}}
  ) {
    edges {
      node {
        date
      }
    }
  }
}` 